import {
  deleteCookie as deleteSharedCookie,
  getCookie as getSharedCookie,
  setCookie as setSharedCookie,
} from "../../utils/auth/cookies";

export function getCookie(name) {
  return getSharedCookie(name);
}

export function createCookie(name, value, days, shareDomain, secure = false) {
  setSharedCookie(name, value, {
    days,
    domain: shareDomain ? ".toyota.com" : undefined,
    sameSite: secure ? "None" : undefined,
    secure,
  });
}

export function deleteCookie(name, shareDomain) {
  deleteSharedCookie(name, {
    domain: shareDomain ? ".toyota.com" : undefined,
  });
}
